import { PayloadAction, createSlice } from '@reduxjs/toolkit';

/**
 * Why the admin step-up prompt is open (ORA-864): the token this device sent
 * was rejected (`expired`), or there was none for an admin-only call
 * (`required`).
 */
export type AdminStepUpPromptReason = 'expired' | 'required';

export interface AdminStepUpState {
  isPromptOpen: boolean;
  reason: AdminStepUpPromptReason | null;
}

const initialState: AdminStepUpState = {
  isPromptOpen: false,
  reason: null,
};

// UI state only; the pending request lives in services/adminStepUpPrompt.ts.
// Not persisted: a prompt must never reopen after a reload.
const adminStepUpSlice = createSlice({
  name: 'adminStepUp',
  initialState,
  reducers: {
    adminStepUpPromptOpened: (
      state,
      action: PayloadAction<AdminStepUpPromptReason>
    ) => {
      state.isPromptOpen = true;
      state.reason = action.payload;
    },
    adminStepUpPromptClosed: (state) => {
      state.isPromptOpen = false;
      state.reason = null;
    },
  },
});

export const { adminStepUpPromptOpened, adminStepUpPromptClosed } =
  adminStepUpSlice.actions;

export default adminStepUpSlice.reducer;
